import React, { useEffect, useRef } from "react";

export default function IframeComponent({
  path,
  id,
  width,
  height,
  fullScreenInMobile,
}) {
  const iframeElem = useRef(null);

  useEffect(() => {
    if (fullScreenInMobile && document.exitFullscreen)
      iframeElem.current.requestFullscreen();
  }, [fullScreenInMobile]);

  return (
    <>
      <iframe
        id={id}
        src={path}
        width={width ? width : "800"}
        height={height ? height : "600"}
        allowFullScreen={true}
        ref={iframeElem}
      ></iframe>
    </>
  );
}
